module.exports = __webpack_public_path__ + "img/185-clipboard.fb11494d.svg";